// extracted by mini-css-extract-plugin
module.exports = {"Container":"Message_Container__oRomj","Header":"Message_Header__3e2gm","Content":"Message_Content__cO-Hu","Footer":"Message_Footer__1syKu"};